<!-- 帮助中心 -->
<template>
  <div id="questionful">
    <Breadcrumb></Breadcrumb>
    <div class="form-body">
      <el-tabs type="border-card" v-model="tabName" @tab-click="handleClick">
        <el-tab-pane
          v-for="(value, key) in menus"
          :key="value.value"
          :name="`${value.value}`"
          :title="value.label"
          :label="value.label"
        >
          <div v-if="tabName == '邀请有奖'">
            <div class="container" style="margin-top: 8px">
              <div class="description" style="">
                <img :src="inviteImage" />
              </div>
            </div>
            <div class="container" style="margin-top: 8px">
              <div class="title clearfix" style="margin-bottom: 8px">
                <div style="float: left">赚钱法则</div>
              </div>
              <div class="description" style="">
                <div>
                  亲爱的会员，为帮助平台更快的成长，希望您帮邀请新的客户，前期你将得到会员套餐10%的奖励，谢谢支持！
                </div>
              </div>
            </div>
            <div class="container" style="margin-top: 8px">
              <div class="title clearfix" style="margin-bottom: 8px">
                <div style="float: left">合作说明</div>
              </div>
              <div class="description" style="">
                <div>
                  公司现大量招聘区域代理，一起拓展市场，审核通过的代理，将成为公司的永久合作伙伴，我们将给与丰厚的待遇，具体合作细节，请联系客服。
                </div>
              </div>
            </div>
            <div class="container" style="margin-top: 8px">
              <div class="title clearfix" style="margin-bottom: 8px">
                <div style="float: left">邀请链接</div>
              </div>
              <div class="description" style="">
                电脑版：
                <el-input
                  style="
                    display: inline-block;
                    width: 600px;
                    margin: 0 39px 0 0;
                  "
                  size="small"
                  v-model="inviteUrl"
                ></el-input>
                <el-button
                  size="small"
                  type="primary"
                  @click="copyText(inviteUrl)"
                  >复制链接</el-button
                >
              </div>
              <div class="description" style="">
                手机版：
                <el-input
                  style="
                    display: inline-block;
                    width: 600px;
                    margin: 0 39px 0 0;
                  "
                  size="small"
                  v-model="inviteUrlAPP"
                ></el-input>
                <el-button
                  size="small"
                  type="primary"
                  @click="copyText(inviteUrlAPP)"
                  >复制链接</el-button
                >
              </div>
              <div class="description" style="position: relative">
                <div style="float: left">二维码：</div>
                <div
                  style="float: left; padding: 17px 0 0 8px"
                  v-if="tabName == '邀请有奖'"
                  id="qrCode"
                  ref="qrCodeDiv"
                ></div>
                <img
                  id="showPayPic"
                  style="position: absolute; left: 142px; top: 93px"
                  :src="customLogo"
                  width="45px"
                />
                <div style="padding: 225px 0 0 121px;">
                  <a @click="download" href="javascript:void(0)"
                    >点击下载图片</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div v-if="tabName == '邀请记录'">
            <el-table :data="tableData">
              <el-table-column label="序号" prop="questionTitle">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column label="邀请时间" prop="questionType">
                <template slot-scope="scope">
                  <span>{{ scope.row.createTime }}</span>
                </template>
              </el-table-column>
              <el-table-column label="邀请的商家" prop="userName">
                <template slot-scope="scope">
                  <span>{{
                    scope.row.nickName ? scope.row.nickName : scope.row.userName
                  }}</span>
                </template></el-table-column
              >
            </el-table>
            <pagination
              v-show="total > 0"
              :total="total"
              :page.sync="queryParams.pageNum"
              :limit.sync="queryParams.pageSize"
              @pagination="loadData"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import {
  getHelpList,
  exportHelpList,
  addHelp,
  updateHelp,
  deleteHelp,
} from "@/api/sysSupport/help"
import CKEditor4 from "@/components/common/CKEditor"
import LocalUpload from "@/components/common/ckEditorUploadPage/localUpload"
import OnlineUpload from "@/components/common/ckEditorUploadPage/onlineUpload"
import { getUserProfile, listInvite } from "@/api/system/user"
import inviteImage from "@/assets/images/invite.png"
import customLogo from "@/assets/images/custom-logo.png"
import QRCode from "qrcodejs2"

export default {
  name: "Help",
  components: {
    Breadcrumb,
    CKEditor4,
    LocalUpload,
    OnlineUpload,
  },
  data() {
    return {
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        questionStatus: "1",
        updateBy: undefined,
        questionTitle: undefined,
        questionType: undefined,
        beginTime: undefined,
        endTime: undefined,
        time: [],
      },
      customLogo: customLogo,
      total: 0,
      inviteUrl: "",
      inviteUrlAPP: "",
      menus: [
        {
          value: "邀请有奖",
          label: "邀请有奖",
        },
        {
          value: "邀请记录",
          label: "邀请记录",
        },
        {
          value: "奖励记录",
          label: "奖励记录",
        },
      ],
      tableData: [],
      tabName: "邀请有奖",
      user: "",
      inviteImage: inviteImage,
      imageSrc: "",
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "user"]),
  },
  created() {
    this.getUserProfile()
  },
  methods: {
    getUserProfile() {
      getUserProfile().then((res) => {
        this.user = res.user
        this.inviteUrl = `https://${window.location.host}/register?t=${this.user.inviteCode}`
        this.inviteUrlAPP = `https://${window.location.host}/app_register?t=${this.user.inviteCode}`
        var qrcode = new QRCode(this.$refs.qrCodeDiv[0], {
          text: this.inviteUrlAPP,
          width: 200,
          height: 200,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        })
        window.setTimeout(() => {
          this.imageSrc = document.querySelector("#qrCode img").src
        }, 100)
      })
    },
    listInvite() {
      this.startLoading()
      let params = {}
      listInvite(params).then((response) => {
        this.tableData = response.rows
        this.total = response.total
        this.endLoading()
      })
    },
    copyText(text) {
      let target = document.createElement("input") //创建input节点
      target.value = text // 给input的value赋值
      document.body.appendChild(target)
      target.value = text // 修改文本框的内容
      target.select() // 选中文本
      document.execCommand("copy") // 执行浏览器复制命令
      this.msgSuccess("复制成功")
       document.body.removeChild(target)
    },

    resetForm() {
      this.$refs["form"].resetFields()
    },

    /**显示编辑页面 */
    handleShowEditHelp(row) {
      this.editDialog.dialogVisible = true
      if (row.questionId) {
        this.editDialog.questionForm = Object.assign({}, row)
        this.editDialog.title = "编辑问题"
      } else {
        this.editDialog.questionForm = { isTop: "0" }
        this.editDialog.title = "新增问题"
        this.editDialog.questionForm.questionStatus = "1"
        this.$nextTick(() => {
          this.editor.setData("")
        })
      }
    },

    /**保存问题信息 */
    handleSaveHelp() {
      this.$refs["questionForm"].validate((valid) => {
        if (valid) {
          this.editDialog.questionForm.content = this.editor.getData()
          let form = this._.clone(this.editDialog.questionForm)
          if (this.editDialog.questionForm.questionId) {
            updateHelp(form).then((response) => {
              if (response.code == "200") {
                this.$message.success("修改成功！")
                this.editDialog.dialogVisible = false
                this.loadData()
              } else {
                this.$message.error("修改失败")
              }
            })
          } else {
            addHelp(form).then((response) => {
              if (response.code == "200") {
                this.$message.success("新增成功！")
                this.editDialog.dialogVisible = false
                this.loadData()
              } else {
                this.$message.error("新增失败")
              }
            })
          }
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    /**删除问题 */
    handleDeleteHelp(row) {
      this.$confirm("确认删除问题？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteHelp(row.questionId).then((response) => {
          if (response.code == "200") {
            this.$message.success("删除成功！")
            this.loadData()
          } else {
            this.$message.error("删除失败！")
          }
        })
      })
    },
    /**详情 */
    handleShowDetail(row) {
      this.$router.push({
        path: "/system/advisory/help_detail",
        query: { questionId: row.questionId },
      })
    },
    download() {
      var imgData = $("#qrCode img").prop("src") //这里放需要下载的base64
      this.downloadFile(new Date().getTime() + ".png", imgData)
    },
    downloadFile(fileName, content) {
      var aLink = document.createElement("a")
      var blob = this.base64ToBlob(content) //new Blob([content]);
      var evt = document.createEvent("HTMLEvents")
      evt.initEvent("click", true, true) //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = fileName
      aLink.href = URL.createObjectURL(blob)
      // aLink.dispatchEvent(evt);
      aLink.click()
    },
    base64ToBlob(code) {
      var parts = code.split(";base64,")
      var contentType = parts[0].split(":")[1]
      var raw = window.atob(parts[1])
      var rawLength = raw.length

      var uInt8Array = new Uint8Array(rawLength)

      for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      return new Blob([uInt8Array], { type: contentType })
    },

    getEditor(editor) {
      this.editor =
        this.localUploadData.editor =
        this.onlineUploadData.editor =
          editor
    },
    openUploadDialog(val) {
      if (val == "local") {
        this.localUploadData.visible = true
      } else if (val == "online") {
        this.onlineUploadData.visible = true
      }
    },
    handleClick() {
      if (this.tabName == "邀请记录") {
        this.listInvite()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-bar-right {
  text-align: right;
}
::v-deep .el-badge__content {
  position: relative;
  top: 6px;
  right: 30px;
}
.form-body {
  margin: 0;
  border: none;
  margin-left: -19px;
}
.title {
  height: 19px;
  line-height: 19px;
  font-size: 17px;
  border-left: 3px solid #f60;
  padding: 0 8px;
  /* margin: 12px 0 0 0; */
  color: #f60;
  font-weight: 600;
}
.container {
  padding: 0px 30px 0px 30px;
  margin-bottom: 16px;
  font-size: 15px;
}
</style>
